import React from 'react';

const InvestmentsLending = () => {
  return (
    <div className="content-section">
      <div className="container mx-auto px-4">
        <div className="glass-card rounded-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-primary mb-6 text-center">
            Investments and Lending
          </h1>
          <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed text-center mb-8">
              Vajreya Ventures excels in strategic investments, acquiring shares, debentures, and securities in domestic and global entities, while providing comprehensive lending solutions and financial services.
            </p>

            <h2 className="text-2xl font-bold text-primary mb-4">Investment Services</h2>
            
            <div className="space-y-4 mb-8">
              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Strategic Investments</h3>
                <p className="text-gray-700">
                  Identify and execute strategic investment opportunities across various sectors and geographies, combining rigorous analysis, market insights, and risk management for superior returns.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Securities Acquisition</h3>
                <p className="text-gray-700">
                  Specialize in acquiring shares, debentures, and securities in domestic and international markets with thorough due diligence and valuation analysis.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Lending Solutions</h3>
                <p className="text-gray-700">
                  Customized lending and financing solutions including corporate financing, project financing, working capital, and bridge financing tailored to specific business needs.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-primary to-primary-dark text-white rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold mb-4">Explore Investment Opportunities</h3>
              <p className="mb-6">
                Partner with Vajreya Ventures for strategic investments and comprehensive financial solutions.
              </p>
              <a 
                href="/contact" 
                className="inline-block px-8 py-3 bg-gold text-white font-semibold rounded-lg hover:bg-gold-dark transition-colors shadow-lg"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestmentsLending;